import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import {
  actRequestOtp,
  actSetOtpErrorMessage,
  actSetStatusCode,
  actShowOtpModal,
  actUpdateAccountPassword,
  actVerifyOtp,
} from 'actions/setting/account';
import { validatePassword } from 'utils/passwordValidator';
import styles from './style.css';
import OtpModalDialog from './OtpModalDialog';

const validate = values => {
  let errors = {};
  if (!values.old_password) {
    errors.old_password = 'Enter a password';
  } else if (/\s/.test(values.old_password)) {
    errors.old_password = 'Enter a valid password';
  } else if (values.old_password.length < 6) {
    errors.old_password = 'Password must be 6 or more characters';
  }

  errors = validatePassword(values.password, values.password_confirmation);
  return errors;
};

class PasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: '',
      newPassword: '',
    };
  }

  handlePasswordSubmit = ({ old_password, password }) => {
    const { accountData } = this.props;
    this.setState(
      {
        oldPassword: old_password,
        newPassword: password,
      },
      () => {
        this.props.dispatch(actRequestOtp(accountData.phone, false));
      }
    );
  };

  submitPasswordData = () => {
    const values = {
      password_confirmation: this.state.oldPassword,
      user: {
        email: this.props.accountData.email,
        password: this.state.newPassword,
      },
    };
    this.props.dispatch(actUpdateAccountPassword({ values }));
  };

  handleResendOtp = phone => {
    this.props.dispatch(actRequestOtp(phone, true));
  };

  handleBackClick = () => {
    this.props.dispatch(actShowOtpModal(false));
    this.props.dispatch(actSetOtpErrorMessage(null));
  };

  handleOtpSubmit = code => {
    const { requestId } = this.props.otp;
    const data = {
      code,
      request_id: requestId,
    };
    this.props.dispatch(actSetStatusCode(null));
    this.props.dispatch(actVerifyOtp(data));
  };

  componentWillReceiveProps(newProps) {
    if (newProps.otp.statusCode !== this.props.otp.statusCode) {
      if (newProps.otp.statusCode === 0) {
        this.submitPasswordData();
      }
    }
  }

  render() {
    const {
      handleSubmit,
      valid,
      onClickBack,
      accountData,
      otp,
      isGoBizAssociated,
    } = this.props;

    if (isGoBizAssociated) {
      return (
        <div className={`row ${styles['pt-25']}`}>
          <div className="col-xs-12">
            <div className={styles['mk-section-header']}>EDIT PASSWORD</div>
            <p className={styles['input-information']}>
              Edit password will be disabled if you login using your GoBiz
              account. To change your GoBiz password, you can reset it through
              the login process or GoBiz App.
            </p>
          </div>
          <form
            className="col-xs-12"
            onSubmit={handleSubmit(this.handlePasswordSubmit)}
          >
            <div className="row">
              <div className="col-xs-12">
                <div className="form-group">
                  <div className={styles['input-label']}>Old Password</div>
                  <Field
                    component={SettingField}
                    type="password"
                    name="old_password"
                    placeholder="Password"
                    showEyeIcon
                    dis
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <div className="form-group">
                  <div className={styles['input-label']}>New Password</div>
                  <Field
                    component={SettingField}
                    type="password"
                    id="new_password"
                    name="password"
                    placeholder="Password"
                    showEyeIcon
                    dis
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <div className="form-group">
                  <div className={styles['input-label']}>
                    Retype New Password
                  </div>
                  <Field
                    component={SettingField}
                    type="password"
                    id="new_password_confirmation"
                    name="password_confirmation"
                    placeholder="Password"
                    dis
                  />
                </div>
              </div>
            </div>
            <div className={`row ${styles['pb-50']}`}>
              <div className="col-2 col-xs-6">
                <button
                  type="button"
                  className={`btn btn-default ${styles['width-100']} ${
                    styles['back-button']
                  }`}
                  onClick={onClickBack}
                >
                  Back
                </button>
              </div>
              <div className="col-12 col-xs-6">
                <button
                  type="submit"
                  disabled
                  className={`btn btn-primary ${styles['width-100']}`}
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      );
    }

    return (
      <div className={`row ${styles['pt-25']}`}>
        <div className="col-xs-12">
          <div className={styles['mk-section-header']}>EDIT PASSWORD</div>
        </div>
        <form
          className="col-xs-12"
          onSubmit={handleSubmit(this.handlePasswordSubmit)}
        >
          <div className="row">
            <div className="col-xs-12">
              <div className="form-group">
                <div className={styles['input-label']}>Old Password</div>
                <Field
                  component={SettingField}
                  type="password"
                  name="old_password"
                  placeholder="Password"
                  maxLength="40"
                  showTextError
                  showEyeIcon
                />
                <div className={styles['input-information']}>
                  Type your Moka account password, not other applications
                  password (google / facebook)
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <div className="form-group">
                <div className={styles['input-label']}>New Password</div>
                <Field
                  component={SettingField}
                  type="password"
                  id="new_password"
                  name="password"
                  placeholder="Password"
                  maxLength="40"
                  showTextError
                  showEyeIcon
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <div className="form-group">
                <div className={styles['input-label']}>Retype New Password</div>
                <Field
                  component={SettingField}
                  type="password"
                  id="new_password_confirmation"
                  name="password_confirmation"
                  placeholder="Password"
                  maxLength="40"
                  showTextError
                />
              </div>
            </div>
          </div>
          <div className={`row ${styles['pb-50']}`}>
            <div className="col-2 col-xs-6">
              <button
                type="button"
                className={`btn btn-default ${styles['width-100']} ${
                  styles['back-button']
                }`}
                onClick={onClickBack}
              >
                Back
              </button>
            </div>
            <div className="col-12 col-xs-6">
              <button
                type="submit"
                disabled={!valid}
                className={`btn btn-primary ${styles['width-100']}`}
              >
                Save
              </button>
            </div>
          </div>
        </form>
        <OtpModalDialog
          onShow={otp.showModal}
          onHide={this.handleBackClick}
          phone={accountData.phone}
          otpError={otp.errorMessage}
          setOtpError={actSetOtpErrorMessage}
          handleOtpAction={actShowOtpModal}
          handleResendOtp={this.handleResendOtp}
          handleOtpSubmit={this.handleOtpSubmit}
        />
      </div>
    );
  }
}

const mapForm = {
  form: 'passwordForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate, // a unique identifier for this form
};

function mapStateToProps(state) {
  const { hermes } = state.setting.account.profile;
  return {
    isGoBizAssociated: !!hermes,
    otp: {
      showModal: state.setting.account.otp_modal,
      requestId: state.setting.account.otp_request_id,
      errorMessage: state.setting.account.otp_error_msg,
      statusCode: state.setting.account.otp_status_code,
    },
  };
}

export default connect(mapStateToProps)(reduxForm(mapForm)(PasswordForm));
